/**
 * Created by Abner Sui on 07/31/2020
 * -------------------------------------
 * Will delete this when all controls are done
 */

import { Component, OnInit, Input } from '@angular/core';
import { FieldConfig, FieldEvents } from './field.model';

@Component({
    selector: 'tam-temp-other',
    templateUrl: './temp-other.component.html',
    styleUrls: ['./field.component.scss']
})
export class TempOtherComponent implements OnInit {

    @Input()
    config: FieldConfig;

    constructor() { }

    ngOnInit() {
    }

    onValueChange(event) {
        this.config.config.feedbackSubject$.next({
            type: FieldEvents.VALUE_CHANGE,
            payload: {
                id: this.config.field.fieldDefinition.id,
                value: event,
            },
        });
    }

}
